export default {
	state: {
		userInfo: {}
	},

	mutations: {
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
		},
		clear(state) {
			state.userInfo = {};
		}
	},
	actions: {
		loadUser(context) {
			return new Promise((resolve, reject) => {
				// 这里留空或添加新的用户加载逻辑
				resolve({});
			});
		}
	}
};
